import * as CheckinQueries from '../../queries/checkin';
import { makeApolloClient, logError } from '../util';

export const FETCH_EVENT_CHECKIN = 'FETCH_EVENT_CHECKIN';
export const UPDATE_EVENT_CHECKIN = 'UPDATE_EVENT_CHECKIN';
export const CREATE_EVENT_CHECKIN = 'CREATE_EVENT_CHECKIN';

const fetchEventCheckin = (eventCheckin, from = '') => ({
	type: FETCH_EVENT_CHECKIN,
	from,
	eventCheckin,
});

export const thunkFetchEventCheckin = (eventID, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { eventCheckIn } = await client.request(CheckinQueries.EVENT_CHECKIN, {
			event_id: eventID,
		});
		dispatch(fetchEventCheckin(eventCheckIn, from));
	} catch (error) {
		logError(error, 'checkin.actions.thunkFetchEventCheckin');
	}
};

export const updateEventCheckin = eventCheckin => ({
	type: UPDATE_EVENT_CHECKIN,
	eventCheckin,
});

export const createEventCheckin = eventCheckin => ({
	type: CREATE_EVENT_CHECKIN,
	eventCheckin,
});
